<div class="page-container">
	<h2
		class="qo-padding20 head-title">
		{{ 'MESSAGE_BOARD.SEEN_BY' | translate }}
		{{(postSeenByInfo$ | async).length}}</h2>
	<div class="line"></div>

	<div class="seen-by-holder">
		<div
			class="seen-by"
			[class.selected]="i %2 === 1 && i > 0"
			*ngFor="let user of (postSeenByInfo$ | async); let i = index"
		>
			<div class="user-profile">
				<qo-profile-image
					[imageUrl]="user.profile_picture ?.download_url"
					[letter]="user.getInitials()"
					[size]="40"
					[fontSize]="20"
				></qo-profile-image>
				<div class="user-name">
					{{user.getFullName()}}
				</div>
			</div>
		</div>
	</div>

	<div class="qo-flex-row-bottom-right qo-padding20 qo-margin-top20 action-button">
		<button class="qo-button-standard qo-grey" (click)="close()">{{'GLOBAL.CLOSE' | translate}}</button>
	</div>
</div>

